import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { fetchPpcAlerts } from "../../../../../redux/slices/store_analytics";

import AlertDrawer from "./AlertDrawer";
import AlertsQueue from "./AlertsQueue";

/**
 * PpcAlerts — Alerts sub-tab inside PPC.
 *
 * Top-level view is the alert queue (rules engine output via
 * /ads-health/{store}). Clicking a row opens a drawer with a chart
 * matched to the alert family:
 *   - BUDGET            → intraday $ vs daily budget (BudgetChartView)
 *   - CPC / EFFICIENCY  → metric block (sparkline coming next)
 *   - AMAZON_DIAGNOSTIC → external link to Amazon Ads
 *
 * We dispatch fetchPpcAlerts in the background so the budget chart
 * drilldown has its raw time series available without an extra round-trip.
 */
export default function PpcAlerts({ store, marketplace }) {
  const dispatch = useDispatch();
  const [selectedAlert, setSelectedAlert] = useState(null);

  useEffect(() => {
    if (!store || store === "all") return;
    // Prime the budget chart payload so the drawer's budget drilldown
    // doesn't need to wait on a separate fetch.
    dispatch(fetchPpcAlerts({ store, marketplace: marketplace || "us" }));
  }, [store, marketplace, dispatch]);

  return (
    <Box>
      <AlertsQueue
        store={store}
        marketplace={marketplace}
        onSelect={setSelectedAlert}
      />
      <AlertDrawer
        open={Boolean(selectedAlert)}
        alert={selectedAlert}
        onClose={() => setSelectedAlert(null)}
      />
    </Box>
  );
}
